import { Entry, IGenericInputFactory, IMoleculeAlert } from '@belong/types';
import { FGenericInput } from '../inputs/genericInput.factory';
import { FMoleculeAlert } from '../molecules/moleculeAlert.factory';

export interface IResendCodeButton {
  description: string;
  buttonLabel: string;
  countDownDescription: string;
}

export interface IOrganismVerificationCodeCapture {
  verificationCodeInput: IGenericInputFactory<'required' | 'invalid'>;
  resendCodeButton: IResendCodeButton;
  resendSuccessfulAlert: IMoleculeAlert;
  resendErrorAlert: IMoleculeAlert;
}

export const FOrganismVerificationCodeCapture = (data: Entry<any>): IOrganismVerificationCodeCapture => {
  const { fields } = data;
  const {
    verificationCodeInput,
    resendButtonDescription,
    resendButtonLabel,
    resendCountDownDescription,
    resendSuccessfulAlert,
    resendErrorAlert
  } = fields;
  return {
    verificationCodeInput: FGenericInput<'required' | 'invalid'>(verificationCodeInput),
    resendCodeButton: {
      description: resendButtonDescription,
      buttonLabel: resendButtonLabel,
      countDownDescription: resendCountDownDescription
    },
    resendSuccessfulAlert: FMoleculeAlert(resendSuccessfulAlert),
    resendErrorAlert: FMoleculeAlert(resendErrorAlert)
  };
};
